/**
 * Sales / customer-service contact points. The WhatsApp number is the same
 * one jarvis-website publishes (src/lib/site.ts, CONTACT.whatsappNumber); keep
 * the two in step when it changes.
 */
export const SALES_WHATSAPP_NUMBER = '6282277700087';
export const SALES_WHATSAPP_DISPLAY = '+62 822-7770-0087';

/** wa.me deep link to sales, with an optional prefilled message. */
export function salesWhatsappLink(message?: string): string {
  const base = `https://wa.me/${SALES_WHATSAPP_NUMBER}`;
  return message ? `${base}?text=${encodeURIComponent(message)}` : base;
}
